<div class="full-page-promo-banner-container">
  <div class="header-container">
    <app-logo link="/" />
    @if (banner) {
      <a
        mat-stroked-button
        class="secondary-button"
        routerLink="/"
        color="primary"
        (click)="clickCloseButton()"
      >
        Close
      </a>
    }
  </div>
  <app-customizable-banner
    view="full-page"
    [spotName]="customizableBannerSpotNames.FULL_PAGE_PROMO_BANNER"
    (bannerChanged)="banner = $event"
  />
</div>
